<v-app class="roboto-font">
  <v-container fluid>
    <h3 class="mt-0">micro frontend: {{ pageHeadline }}</h3>
    <mfe-drawer v-model="showDrawer" :items="logs"></mfe-drawer>
    <v-sheet border="dashed md" class="pa-1" width="100%" ref="microfrontend-instance-host">
      <v-skeleton-loader v-if="mfeHasBeenRenderedOnce && !isMfeRendered" type="article"></v-skeleton-loader>
      <p v-if="mainScreenMessage" class="text-display-medium text-center text-disabled">{{ mainScreenMessage }}</p>
    </v-sheet>
    <v-divider class="border-opacity-100 my-1"></v-divider>
    <v-btn
      prepend-icon="mdi-eye-outline"
      color="primary"
      class="mr-2"
      @click="createMicrofrontend"
      :disabled="!isCreateButtonActive"
      >Create micro frontend</v-btn
    >
    <v-btn
      prepend-icon="mdi-content-save-outline"
      color="indigo-lighten-5"
      class="mr-2"
      :disabled="!isCreateButtonActive"
      @click.stop="triggerSaveOnMicrofrontend"
      >Save consents</v-btn
    >
    <v-btn
      prepend-icon="mdi-calendar-star"
      color="indigo-lighten-5"
      class="mr-2"
      @click.stop="showDrawer = true"
      :disabled="!isCreateButtonActive"
    >
      Show events
      <v-chip v-if="unreadNotificationCount > 0" variant="tonal" size="x-small" color="primary" class="ml-2"
        >{{ unreadNotificationCount }}</v-chip
      >
    </v-btn>

    <v-btn
      prepend-icon="mdi-content-copy"
      color="indigo-lighten-5"
      @click.stop="copyUrlToClipboard"
      :disabled="!isCreateButtonActive"
      >Copy current config URL</v-btn
    >

    <v-btn :href="advancedModeUrl" variant="plain" prepend-icon="mdi-cards-playing-outline"
      >Switch to advanced mode</v-btn
    >

    <v-card title="Settings" subtitle="Configure your microfrontend and press 'Create micro frontend'" class="mt-2">
      <v-card-text>
        <v-form>
          <v-row align="center" v-if="showClientSelectField">
            <v-col cols="4" class="text-title-medium"> Client </v-col>
            <v-col cols="8">
              <mfe-client-select :value="client" @change="(id) => client = id"></mfe-client-select>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="4" class="text-title-medium"> Service Provider Id ("spId") </v-col>
            <v-col cols="8">
              <mfe-service-provider-select :value="spId" @change="(id) => spId = id"></mfe-service-provider-select>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="4" class="text-title-medium"> Local Customer Id ("lcId") </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="lcId"
                label="Local customer Id"
                type="text"
                density="compact"
                variant="outlined"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="4" class="text-title-medium"> Lifecycle </v-col>
            <v-col cols="8">
              <mfe-lifecycle-select :value="lifecycle" @change="(id) => lifecycle = id"></mfe-lifecycle-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</v-app>

<Teleport to="head">
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://cdn.jsdelivr.net" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css" />
  <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
</Teleport>
